// flow weak

import React, {
    PureComponent,Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import DatePicker from 'react-datepicker';
  import {addDays}  from 'material-ui/DatePicker/dateUtils';
  import TimeField from 'react-simple-timefield';
  
  class EditCourtPricingRule extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        details: {
            venue: '',
        },
        message:'',
        venue_list: [],
        revenue_target_list:[],
        loading: false,
        selected_venue:'',
      };
      this.handleVenueChange = this.handleVenueChange.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.getRevenueTargetsforVenue = this.getRevenueTargetsforVenue.bind(this);
      this.postUpdateTargetForVenue = this.postUpdateTargetForVenue.bind(this);

    }
  
    componentDidMount() {
        this.getVenueList();

        
    }

    getVenueList(){
        const url = `${getLocationOrigin()}/court/get_rental_venue_for_buddy/`;
         const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => {this.setState({ venue_list: data.results}),
            this.setState({selected_venue:data.results[0].id,new_selected_venue:data.results[0].id}),
            this.getRevenueTargetsforVenue(this.state.selected_venue,this.state.selected_day)
          })
           .catch(error => error);
    }

    
    getRevenueTargetsforVenue(venue_id,game){
        var new_selected_one =  Object.assign({}, this.state.details);
        new_selected_one['venue'] = venue_id
        var day = this.state.selected_day
        console.log("getRevenueTargetsforVenue")
        this.setState({details: new_selected_one});
        const url = `${getLocationOrigin()}/cm/getRevenueTargetsforVenue/?venue_id=${venue_id}&day=${day}`;
        const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({ revenue_target_list: data.revenue_target_list}),
                    console.log("data")
            )
           .catch(error => error);
    }

    
    handleVenueChange(event){
      console.log(event.target.value)
     
      this.state.game_list = this.state.venue_list.filter(venue => venue.id == event.target.value)[0].games
      // var new_game_id = this.state.game_list[0].game_id
      console.log(this.state.venue_list)
      console.log(this.state.game_list)
      this.setState({selected_venue:event.target.value,selected_game:this.state.game_list[0].game_id})
      this.getRevenueTargetsforVenue(event.target.value,this.state.selected_day)

      // this.getSlots(event.target.value)
    }

    

    handleChange(event) {
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.details);
        new_value[name] = event.target.value
        this.setState({details: new_value});
    }

    handleFormSubmit(event){
        event.preventDefault();
        this.check_availability(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes,this.props)
        // this.postBulkBooking(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes, this.props)
    }

    

    handleOpen = () => {
        this.setState({dialog_open_cust:true,dialog_open_failed_list:true});
    };

    
    
    handleClose = () => {
    this.setState({dialog_open_cust:false, dialog_open_court_list:false,dialog_open_failed_list:false,deleteOption:false});
    };


    updateRevenueTarget(event,revenue_record)
      { console.log(revenue_record)
        console.log("updateRevenueTarget")
        var new_list = this.state.revenue_target_list
        for(var i=0;i<this.state.revenue_target_list.length;i++){
          if(revenue_record == new_list[i].id){
            new_list[i].value = event.target.value
            this.setState({revenue_target_list:new_list})
          }
        }
      }

    
    


    postUpdateTargetForVenue(){
            const url = `${getLocationOrigin()}/cm/updateRevenueTarget/`;
            console.log(this.state.new_court_price)
            const options = {...defaultOptions};
            options['method'] = 'post'
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'revenue_target_list': this.state.revenue_target_list,

                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                  
                alert(response.message);
                window.location.reload();
                this.setState({new_target_price:0})
                // props.history.goBack();
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                this.setState({loading:false})
            });

    }

    

    
  
    render() {
      console.log('render')
      console.log(this.state)
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Add"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];
      const dialog_actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Delete"
          primary={true}
          onClick={this.postDeleteCourtPrice}
        />,
      ];

      const okaction = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleClose}
        />
      ];

      var days = [{"name":"Monday","id":0},{"name":"Tuesday","id":1},{"name":"Wednesday","id":2},{"name":"Thrusday","id":3},{"name":"Friday","id":4},{"name":"Saturday","id":5},{"name":"Sunday","id":6}]
      var TYPES = [{"name":"Court Rental","id":0},{"name":"Equipment Rental","id":1},{"name":"F&B Rental","id":2},{"name":"Service Rental","id":3}]
      
      return(
        <div style={styles.container}>
            <div style={styles.main_header} className="col-md-12">
                                          Edit Revenue Target
                                        </div>
            <div className="col-md-8" style={{'hight':"100px",'display':"flex",'flexDirection':"row",'fontSize':"16px",}}>
                  <div className="col-md-6">Select Venue 
                  </div>
                  <div className="col-md-6" style={{'hight':"100px"}}>
                    <select name="venue" className="col-md-10" style={styles.item_body} style={{backgroundColor:'white',width:'100%'}} value={this.state.value}
                      onChange={this.handleVenueChange}>
                    {this.state.venue_list.map((venue,index) =>
                    <option key={venue.id} value={venue.id}>{venue.name}</option>
                     )} 
                    </select>
                  </div>
                  
            </div>

            
            

          <div style={styles.table}>
                <div style={{'color':"#17DED7",'marginTop':"5px",'fontSize':"22px",'textAlign':"center"}}>All Targets
                </div>
                <div  style={{'color':"#CD85F9",'marginTop':"10px",'fontSize':"18px",'textAlign':"center",'display':"flex",'flexDirection':"row"}}>
                            <div style={{'marginLeft':"20px",'width':"15%"}}>
                              TYPE
                            </div>
                            <div style={{'marginLeft':"10px",'width':"12%"}}>
                              MONDAY
                            </div>
                            <div style={{'marginLeft':"5px",'width':"12%"}}>
                              TUESDAY
                            </div>
                            <div style={{'marginLeft':"5px",'width':"13%",'fontSize':"17px"}}>
                              WEDNESDAY
                            </div>
                            <div style={{'marginLeft':"5px",'width':"12%"}}>
                              THURSDAY
                            </div>
                            <div style={{'marginLeft':"5px",'width':"12%"}}>
                              FRIDAY
                            </div>
                            <div style={{'marginLeft':"5px",'width':"12%"}}>
                              SATURDAY
                            </div>
                            <div style={{'marginLeft':"5px",'width':"12%"}}>
                              SUNDAY
                            </div>
                            
                </div>
                <div  style={{'textAlign':"left"}}>
                {TYPES.map((type,index) => 
                  <div style={{'display':"flex",'flexDirection':"row",'fontSize':"18px",'marginTop':"2px",'backgroundColor':"#B195E1",'hight':"30px"}}>
                    <div style={{'marginLeft':"20px",'width':"15%"}}>{type.name}</div>
                    
                              <div style={{'width':"12%"}}>
                                { this.state.revenue_target_list.map((target,index) =>
                                              <div  style={{'fontSize':"20px",'textAlign':"center",'display':"flex",'flexDirection':"column"}}>
                                                        {target.day_of_week == 0 && target.target_type == type.id ? <div>
                                                          <input type="number" style={styles.input} className="required" name="advance_amount" value={this.state.value} placeholder={target.value}
                                                              onChange={(event)=>{this.updateRevenueTarget(event,target.id)}}/>
                                                          </div> :null
                                                        }
                                              </div>
                                )}
                              </div>
                              <div style={{'width':"12%"}}>
                                { this.state.revenue_target_list.map((target,index) =>
                                    <div  style={{'fontSize':"20px",'textAlign':"center"}}>
                                                        {target.day_of_week == 1 && target.target_type == type.id ? <div>
                                                          <input type="number" style={styles.input} className="required" name="advance_amount" value={this.state.value} placeholder={target.value}
                                                              onChange={(event)=>{this.updateRevenueTarget(event,target.id)}}/>
                                                          </div> :null
                                                        }
                                              </div>
                                )}
                              </div>
                              <div style={{'width':"12%"}}>
                                { this.state.revenue_target_list.map((target,index) =>
                                    <div  style={{'fontSize':"20px",'textAlign':"center"}}>
                                                        {target.day_of_week == 2 && target.target_type == type.id ? <div>
                                                          <input type="number" style={styles.input} className="required" name="advance_amount" value={this.state.value} placeholder={target.value}
                                                              onChange={(event)=>{this.updateRevenueTarget(event,target.id)}}/>
                                                          </div> :null
                                                        }
                                              </div>
                                )}
                              </div>
                              <div style={{'width':"12%"}}>
                                { this.state.revenue_target_list.map((target,index) =>
                                    <div  style={{'fontSize':"20px",'textAlign':"center"}}>
                                                        {target.day_of_week == 3 && target.target_type == type.id ? <div>
                                                          <input type="number" style={styles.input} className="required" name="advance_amount" value={this.state.value} placeholder={target.value}
                                                              onChange={(event)=>{this.updateRevenueTarget(event,target.id)}}/>
                                                          </div>   :null                                                      }
                                              </div>
                                )}
                              </div>
                              <div style={{'width':"12%"}}>
                                { this.state.revenue_target_list.map((target,index) =>
                                    <div  style={{'fontSize':"20px",'textAlign':"center"}}>
                                                        {target.day_of_week == 4 && target.target_type == type.id ? <div>
                                                          <input type="number" style={styles.input} className="required" name="advance_amount" value={this.state.value} placeholder={target.value}
                                                              onChange={(event)=>{this.updateRevenueTarget(event,target.id)}}/>
                                                          </div>       :null                                                  }
                                              </div>
                                )}
                              </div>
                              <div style={{'width':"12%"}}>
                                { this.state.revenue_target_list.map((target,index) =>
                                    <div  style={{'fontSize':"20px",'textAlign':"center"}}>
                                                        {target.day_of_week == 5 && target.target_type == type.id ? <div>
                                                          <input type="number" style={styles.input} className="required" name="advance_amount" value={this.state.value} placeholder={target.value}
                                                              onChange={(event)=>{this.updateRevenueTarget(event,target.id)}}/>
                                                          </div>      :null                                                   }
                                              </div>
                                )}
                              </div>
                              <div style={{'width':"12%"}}>
                                { this.state.revenue_target_list.map((target,index) =>
                                    <div  style={{'fontSize':"20px",'textAlign':"center"}}>
                                                        {target.day_of_week == 6 && target.target_type == type.id ? <div>
                                                          <input type="number" style={styles.input} className="required" name="advance_amount" value={this.state.value} placeholder={target.value}
                                                              onChange={(event)=>{this.updateRevenueTarget(event,target.id)}}/>
                                                          </div> :null
                                                        }
                                              </div>
                                )}
                              </div>
                  </div>
                
                )}
                </div>
          </div>
          <div className="col-md-12" style={{'hight':"100px",'marginTop':"20px",'fontSize':"16px",'float':"center"}}>
              <input type="button" style={{'backgroundColor':"#32b6a7",'fontSize':"20px",'width':"20%"}} value="SAVE" onClick={()=>{this.postUpdateTargetForVenue()}} />
          </div>

          
      </div>
    );
    }
  }
  export default EditCourtPricingRule;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editRevenueTarget/index.js